import React, { PureComponent } from 'react';
import Dimensions from './Dimensions';
import { DivWithPopover } from 'common/components/core/wrappers/Div';
import Units from 'common/enums/UnitEnum';

class VehicleDimension extends PureComponent {
    onChange = (index, volume) => {
        const { onChange, entity } = this.props;
        onChange?.(entity.setVehicleVolume(volume));
    };

    onDimensionsChange = (index, dimensions) => {
        const { onChange, entity } = this.props;
        let updatedEntity = entity;
        if (!dimensions.hasValidationErrors() && dimensions.isFilled()) {
            const { volume } = updatedEntity;
            const updatedVolume = volume.setValue(dimensions.getTotalVolume());
            updatedEntity = updatedEntity.setVehicleVolume(updatedVolume);
        }
        updatedEntity = updatedEntity.setDimensions(dimensions);
        onChange?.(updatedEntity);
    };

    render() {
        const { entity, t, theme, unitConverter } = this.props;
        const { vehicleVolume, dimensions, volumeUnit } = entity;
        const popOverMessage =
            dimensions?.isFilled() && entity.validateVehicleVolume();
        return (
            <DivWithPopover
                isPopOverOpen={!!popOverMessage}
                popOverContent={popOverMessage}
            >
                <Dimensions
                    t={t}
                    hideVolumeInput
                    theme={theme}
                    volume={vehicleVolume}
                    dimensions={dimensions}
                    onChange={this.onChange}
                    onDimensionsChange={this.onDimensionsChange}
                    volumeUnit={volumeUnit}
                    unitConverter={unitConverter}
                    distanceUnit={Units.list.length.Meter}
                    preferredVolumeUnit={Units.list.volume.CubicMeter}
                />
            </DivWithPopover>
        );
    }
}

export default VehicleDimension;
